"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var TabMenuContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &:empty {\n    min-height: 3.2rem;\n\n    @media (max-width: 768px) {\n      min-height: 2rem;\n    }\n  }\n"], ["\n  &:empty {\n    min-height: 3.2rem;\n\n    @media (max-width: 768px) {\n      min-height: 2rem;\n    }\n  }\n"])));
var TabMenuNav = styled_components_1.default.nav(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n"], ["\n  display: flex;\n  position: relative;\n"])));
var TabMenuWrapper = styled_components_1.default.ul(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 3px;\n  margin: 0;\n  display: flex;\n  justify-content: space-between;\n  overflow-x: auto;\n  overflow-y: hidden;\n\n  // untestable as none of the renders actually render layout so the listElement will always be 0\n  /* istanbul ignore next */\n  ", "\n"], ["\n  padding: 3px;\n  margin: 0;\n  display: flex;\n  justify-content: space-between;\n  overflow-x: auto;\n  overflow-y: hidden;\n\n  // untestable as none of the renders actually render layout so the listElement will always be 0\n  /* istanbul ignore next */\n  ", "\n"])), function (_a) {
    var showFade = _a.showFade;
    if (showFade) {
        return "\n        margin-right: -1rem;\n        margin-left: -1rem;\n        padding-left: 1rem;\n\n        a:last-child,\n        button:last-child {\n          padding-right: 1rem;\n        }\n\n        &::before {\n          content: '';\n          position: absolute;\n          top: -1.2rem;\n          left: -1rem;\n          width: 1rem;\n          height: 5.2rem;\n          background-image: linear-gradient(\n            to left,\n            rgba(255, 255, 255, 0) 0%,\n            ".concat(b2c_theme_1.colors.white, " 80%,\n            ").concat(b2c_theme_1.colors.white, " 100%\n          );\n          pointer-events: none;\n          z-index: 10;\n        }\n\n        &::after {\n          content: '';\n          position: absolute;\n          top: -1.2rem;\n          right: -1rem;\n          width: 1rem;\n          height: 5.2rem;\n          background-image: linear-gradient(\n            to right,\n            rgba(255, 255, 255, 0) 0%,\n            ").concat(b2c_theme_1.colors.white, " 80%,\n            ").concat(b2c_theme_1.colors.white, " 100%\n          );\n          pointer-events: none;\n          z-index: 10;\n        }\n      ");
    }
});
var TabMenu = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    var _b = (0, react_1.useState)(null), width = _b[0], setWidth = _b[1];
    var _c = (0, react_1.useState)(false), showFade = _c[0], setShowFade = _c[1];
    var container = (0, react_1.createRef)();
    (0, react_1.useEffect)(function () {
        function handleResize() {
            setWidth(window === null || window === void 0 ? void 0 : window.innerWidth);
        }
        window === null || window === void 0 ? void 0 : window.addEventListener('resize', handleResize);
        handleResize();
        return function () { return window === null || window === void 0 ? void 0 : window.removeEventListener('resize', handleResize); };
    }, []);
    (0, react_1.useEffect)(function () {
        var listElement = container.current;
        if (listElement && width) {
            setShowFade(listElement.scrollWidth > listElement.offsetWidth);
        }
    }, [width]);
    return (react_1.default.createElement(TabMenuContainer, __assign({ "data-testid": "tab-menu-container" }, rest),
        react_1.default.createElement(TabMenuNav, null,
            react_1.default.createElement(TabMenuWrapper, { "data-testid": "tab-menu-wrapper", ref: container, showFade: showFade }, children))));
};
exports.default = TabMenu;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=TabMenu.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/TabMenu/TabMenu.js
// module id = 1500
// module chunks = 2 5 6 16 18 19